// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__Mru9Z","logo":"App_logo__7Edbg","tabContent":"App_tabContent__jGtJ0","mobile":"App_mobile__LWcL+","show":"App_show__OajUc"};